import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function Header() {
  return {
    handleToggle({ detail }, isOpen) {
      const { id } = detail;
      if (id === 'mainNav') {
        if (isOpen) {
          disableBodyScroll(this.$el);
        } else {
          enableBodyScroll(this.$el);
        }
      }
    },
  };
}

export default Header;
